export default {"src":"/_next/static/media/instagram.aba32196.svg","height":33,"width":33};